import SlotComponent from '../../../SlotComponent';

const ErrorState = ({ ErrorState, blockClass, ...rest }: any) => {
	if (!ErrorState)
		return (
			<p
				className={`defaultErrorMessage ${blockClass ? `defaultErrorMessage--${blockClass} vtex-store-newsletter-1-x-defaultErrorMessage--${blockClass}` : ''} vtex-store-newsletter-1-x-defaultErrorMessage`}
			>
				Algo deu errado e não conseguimos efetuar seu cadastro.
			</p>
		);
	return <SlotComponent props={{ ...ErrorState, blockClass, ...rest }} />;
};

export default ErrorState;
